// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-unlocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.499 17.5H21.499V22H14.499V17.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4V22H10.5M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.75 17.5V15.75C15.75 14.5074 16.7574 13.5 18 13.5C18.6188 13.5 19.1793 13.7498 19.5861 14.1541M14.499 17.5H21.499V22H14.499V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileUnlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-unlocked',
    ref,
    icon: element,
  },
));

FileUnlockedIcon.displayName = 'FileUnlockedIcon';

export default FileUnlockedIcon;
